import connectTransport from "../connect"
import HomePage from "./HomePage"

export default connectTransport(HomePage)
